import { Component, OnInit, Input } from '@angular/core';
import { User } from '../../models/user';
import { Document } from '../../models/document';
import { InfostechniquesService } from '../../services/infostechniques.service';
import { Infostechniques, Infos } from '../../models/infostechniques';

@Component({
  selector: 'step-infostechniques',
  templateUrl: './infostechniques.component.html',
  styleUrls: ['./infostechniques.component.scss']
})
export class InfostechniquesComponent implements OnInit {


  @Input() currentuser: User;
  @Input() currentdocument: Document;

  infostechniques: Infostechniques;
  selectedSocial: Infos[] = [];
  selectedAdherents: Infos[] = [];

  constructor(
    private serviceinfostechniques: InfostechniquesService
  ) { }

  ngOnInit() {
    this.getInfosTechniques();
  }

  getInfosTechniques(){
    this.serviceinfostechniques.getInfostechniques().subscribe((infostech: Infostechniques) => {
      this.infostechniques = infostech;
      this.selectedSocial = infostech[0].reseaux_sociaux.filter(rs => {rs.selected === true; console.log('rs' + JSON.stringify(rs.selected))});
      console.log('selected : ' + this.selectedSocial);
    });
  }

  selectSocial(social: Infos){
    this.selectElement(social, this.selectedSocial);
  }

  selectAdherents(adherent: Infos){
    this.selectElement(adherent, this.selectedAdherents);
  }

  protected selectElement(object: Infos, attribute: Infos[]){
    object.selected = !object.selected;
    let index = attribute.indexOf(object);
    if (index > -1){
      attribute.splice(index, 1);
    } else {
      attribute.push(object);
    }
  }

  backofficeselected(event) {
    return event;
  }

  saveInfosTechniques(){
    this.serviceinfostechniques.saveInfosTechniques(this.infostechniques, this.currentdocument.id,this.currentuser.id);
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/infostechniques/infostechniques.component.ts